import { memo } from 'react';

import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import type { FamilyEvent } from '@/features/guardian/family-events';
import { createStyles, useScaling } from '@/hooks';

type FamilyCalendarEventChipProps = {
  event: FamilyEvent;
};

function FamilyCalendarEventChip({ event }: FamilyCalendarEventChipProps) {
  const { scale } = useScaling();
  const styles = useStyles();
  const isPractice = event.type === 'practice';

  return (
    <Stack
      borderRadius={scale(4)}
      paddingX={scale(4)}
      paddingY={scale(2)}
      justify="center"
      style={isPractice ? styles.practiceChip : styles.tournamentChip}>
      <Text
        numberOfLines={1}
        fontFamily="OpenSans"
        fontSize={scale(8)}
        lineHeight={scale(12)}
        fontWeight={'400'}
        style={isPractice ? styles.practiceText : styles.tournamentText}>
        {event.title}
      </Text>
    </Stack>
  );
}

const useStyles = createStyles(() => ({
  practiceChip: {
    backgroundColor: '#DDF7F1',
  },
  tournamentChip: {
    backgroundColor: '#E4EBFC',
  },
  practiceText: {
    color: '#16A98E',
  },
  tournamentText: {
    color: '#346AE1',
  },
}));

export default memo(FamilyCalendarEventChip);
